<template>
  <div>
    <privacy-notice></privacy-notice>

    <form-button pull="right"
                 color="blue"
                 @click="submit">
      I accept
    </form-button>
  </div>
</template>

<script>
import PrivacyNotice from '../PrivacyNotice';
import FormButton from '../elements/FormButton';

export default {
  components: {
    PrivacyNotice,
    FormButton,
  },

  data() {
    return {};
  },

  methods: {
    submit() {
      this.$emit('submit', {
        consentDate: new Date().toISOString(),
      });
    },
  },
};
</script>

<style scoped>
.collection-list {
  padding-left: 12px;
}
.collection-list li {
  font-size: 85%;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/Consent.vue